export enum TrackingCategory {
  PERSON_PAGE = 'Person Credit History | MX',
}

export enum TrackingAction {
  PERSON_PAGE_LOAD = 'Credit History Load | Person Page',
  PERSON_PAGE_COMPLETE = 'Credit History Submit | Person Page',
}

export enum TrackingEvent {
  CREDIT_HISTORY = 'gaCreditHistoryMX',
}
